import "./index.css";
import { DuplicateButton } from "../../../../components/DuplicateButton";
import plusIcon from "../../../../assets/design-revamp-product/product-icons/plus-icon-product.svg";
import ProductModal from "../ProductModal";
import { useState, useCallback } from "react";
import checkIcon from "../../../../assets/design-revamp-product/product-icons/checkbox-product.svg";
import defaultCheck from "../../../../assets/design-revamp-product/product-icons/unselected-product-checkbox.svg";

const ProductComponentBox = ({
  productId,
  name,
  subgroup,
  variationValues,
  prodNum,
  isAddNew,
  year,
  subgroupId,
  business,
  subgroups,
  isAR,
  isSelected,
  onSelect,
  noBtn,
}) => {
  const [open, setOpen] = useState(false);
  const handleDuplicateClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handleBoxClick = useCallback(() => {
    if (isAddNew) {
      setOpen(true);
    }
  }, [isAddNew]);

  const handleCheckboxClick = (e) => {
    e.stopPropagation();
    if (onSelect) {
      onSelect();
    }
  };

  const EllipsisText = ({ text, maxLength = 6 }) => {
    const truncatedText =
      text.length > maxLength ? text.slice(0, maxLength) + "..." : text;

    return <span>{truncatedText}</span>;
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        position: "relative",
        width: "171px",
        height: "210px",
        ...(isAddNew ? { marginLeft: "12px" } : {}),
        cursor: "pointer",
      }}
      onClick={handleBoxClick}
    >
      <div className="product-component-title">
        {name ? name : "Product name"}
      </div>
      <div
        className="product-component-body"
        style={{
          backgroundColor: isAR
            ? "rgba(102, 70, 80, 0.8)"
            : "rgba(221, 210, 216, 1)",
        }}
      >
        {isAddNew ? (
          <>
            <p style={{ fontSize: "14px" }}>Add Product</p>
            <img
              src={plusIcon}
              width={80}
              height={80}
              alt="Add new product"
              style={{ margin: "0 auto" }}
            />
          </>
        ) : (
          <>
            <p>{subgroup || ""}</p>
            {variationValues?.length > 0 &&
              variationValues.map((category, categoryIndex) => (
                <div key={`category-${categoryIndex}`}>
                  {category?.values?.map((value, valueIndex) => (
                    <p key={`value-${categoryIndex}-${valueIndex}`}>
                      {value.value}
                    </p>
                  ))}
                </div>
              ))}
          </>
        )}
      </div>
      <div className="product-component-bottom">
        <span>#</span>
        {prodNum ? <EllipsisText text={prodNum} /> : ""}
      </div>
      {!isAddNew && !isAR && (
        <DuplicateButton id={productId} onClick={handleDuplicateClick} />
      )}
      {isAR && !noBtn && (
        <div
          style={{
            position: "absolute",
            bottom: "12px",
            right: "-3px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {isSelected ? (
            <img
              src={checkIcon}
              width={25}
              height={25}
              alt="Selected Checkbox"
              onClick={handleCheckboxClick}
              style={{ cursor: "pointer" }}
            />
          ) : (
            <img
              src={defaultCheck}
              width={25}
              height={25}
              alt="Unselected Checkbox"
              onClick={handleCheckboxClick}
              style={{ cursor: "pointer" }}
            />
          )}
        </div>
      )}
      {open && (
        <ProductModal
          onClose={handleCloseModal}
          year={year}
          subgroupId={subgroupId}
          business={business}
          subgroups={subgroups}
        />
      )}
    </div>
  );
};

export default ProductComponentBox;
